module.exports = __webpack_public_path__ + "img/cover.aeee9891.jpg";